import { render } from "./UpdateStudents.vue?vue&type=template&id=79b54290"
import script from "./UpdateStudents.vue?vue&type=script&lang=js"
export * from "./UpdateStudents.vue?vue&type=script&lang=js"

import "./UpdateStudents.vue?vue&type=style&index=0&id=79b54290&lang=scss"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__